module.exports = __webpack_public_path__ + "media/images/emblems/Zizers_wappen-6ee7becae55dfab5d337d38f63ad052d.svg";